var _path, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d1d5db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M18.5 47V17"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ef4444",
    d: "m23.93 17.13 3.59.53a.79.79 0 0 1 .68.79v9.21a.8.8 0 0 1-.68.79l-3.59.55a.8.8 0 0 1-.92-.79V17.92a.81.81 0 0 1 .92-.79z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-0.1 1; 0 0; -0.1 -1; 0 0; -0.1 1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ef4444",
    d: "m32.58 18.27 3.59.52a.8.8 0 0 1 .68.79v6.94a.8.8 0 0 1-.68.79l-3.59.53a.8.8 0 0 1-.92-.79v-8a.8.8 0 0 1 .92-.78z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.1s",
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-0.1 1; 0 0; -0.1 -1; 0 0; -0.1 1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ef4444",
    d: "m41.22 19.4 3.6.53a.79.79 0 0 1 .68.79v4.67a.8.8 0 0 1-.68.79l-3.6.52a.79.79 0 0 1-.91-.79v-5.72a.8.8 0 0 1 .91-.79z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.2s",
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-0.1 1; 0 0; -0.1 -1; 0 0; -0.1 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSolid);
export default __webpack_public_path__ + "static/media/wind-solid.40bda27b83042efd18320c0dca9f147a.svg";
export { ForwardRef as ReactComponent };